import React from "react";
import componentStyle from './DragSource.module.scss'
const DragSource = React.forwardRef( (draggable, ref) => {
    const {className, data, disabled, optionattributes, style} = draggable
    const convertToStyles = data.aS.split(' ').reduce((prev, curr, i, arr) => {
        //console.log('curr = ',curr, componentStyle[curr])
        const returnVar = curr ? (componentStyle[curr] || curr) : ''
        return `${prev}${returnVar!=='' ? ' '+returnVar:''}`
    }, '')
    let elapsedTime
    if (Array.isArray(draggable?.all)) {
       
       let skip = false;
       let seconds = 0
       draggable.all.forEach( d => {
           if (skip) return

           seconds += d.timeMin * 60 + d.timeSec 
           skip =  d.i === draggable.data.i
       })
        function fmtMSS(s){return(s-(s%=60))/60+(9<s?':':':0')+s}

        elapsedTime = fmtMSS(seconds)
    }
    
    return <div ref={ref}
                data-handler-id={draggable.dnd_id}
                // className={`Draggable draggable-${draggable.data.class} `}
                className={`Draggable draggable-${draggable.data.class} ${componentStyle.item}${className ? ' '+className :''}${convertToStyles!=='' ? ' '+convertToStyles : ''}`}
               // style={draggable.data.style}
    >
        <div className={'drag-content'} dangerouslySetInnerHTML={ {__html: draggable.data.html}} />
        <div className={'time hidden'} >{`${elapsedTime || ''}`}</div>
    </div>
})

export default DragSource